<template>
  <div name="hres4ax-popup1" id="hres4ax-popup1" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header header-popup1">
          <button id="button-popup1" type="button" class="close" data-dismiss="modal" >&times;</button>
          <h4 class="modal-title">{{ labels['HRES4AXC4']['10'] }}</h4>
        </div>

        <div class="modal-body detail detail-responsive">
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-3 control-label">{{ labels['HRES4AXC4']['20'] }}</label>
              <div class="col-md-6">
                <div class="form-control readonly-field-color">{{popup1.detail.codcompy}} - {{popup1.detail.desc_codcompy}}  </div>
              </div>
            </div>

            <div class="form-group margin-b-5">
              <label class="col-md-3 control-label">{{ labels['HRES4AXC4']['30'] }}</label>
              <div class="col-md-6">
                <div class="form-control readonly-field-color">{{popup1.detail.codlinef}} - {{popup1.detail.desc_codlinef}}  </div>
              </div>
            </div>

            <div class="form-group margin-b-5">
              <label class="col-md-3 control-label">{{ labels['HRES4AXC4']['40'] }}</label>
              <div class="col-md-6">
                <div class="form-control readonly-field-color">{{setDateOutput(popup1.detail.dteeffec)}}</div>
              </div>
            </div>

            <div class="form-group margin-b-5">
              <label class="col-md-3 control-label">{{ labels['HRES4AXC4']['50'] }}</label>
              <div class="col-md-6">
                <div class="form-control readonly-field-color">{{popup1.detail.desc_codcomp}}</div>
              </div>
            </div>

            <div class="form-group margin-b-5">
              <label class="col-md-3 control-label">{{ labels['HRES4AXC4']['60'] }}</label>
              <div class="col-md-6">
                <div class="form-control readonly-field-color">{{popup1.detail.desc_codpos}}</div>
              </div>
            </div>
          </form> 

          <br>

          <div class="box-tab">
            <div id="accordion"> 
              <popup1-tab1 :labels="labels" 
                          :data="popup1.tab1"
                          :popup1Tab1Table="popup1Tab1Table" />

              <popup1-tab2 :labels="labels"
                          :data="popup1.tab2"
                          :popup1Tab2Table="popup1Tab2Table" />

              <popup1-tab3 :labels="labels"
                          :data="popup1.tab3"
                          :popup1Tab3Table="popup1Tab3Table" />

              <popup2     :labels="labels"
                          :detail="detail"
                          :popup2="popup2"
                          :popup2Tab2Table="popup2Tab2Table"
                          :popup2Tab3Table="popup2Tab3Table" />


            </div>  
          </div>  
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import popup1Tab1 from 'components/hres4ax/popup1Tab1'
import popup1Tab2 from 'components/hres4ax/popup1Tab2'
import popup1Tab3 from 'components/hres4ax/popup1Tab3'
import popup2 from 'components/hres4ax/popup2'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hres4ax-popup1',
  props: [ 'nowLang', 'labels', 'popup1', 'popup1Tab1Table', 'popup1Tab2Table', 'popup1Tab3Table', 'detail', 'popup2', 'popup2Tab2Table', 'popup2Tab3Table' ],
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  },
  components: {
    popup1Tab1,
    popup1Tab2,
    popup1Tab3,
    popup2
  }
}
</script>



// WEBPACK FOOTER //
// popup1.vue?dfb6ebbe